import React, { useMemo } from "react";
import CodeMirrorTextArea from "../../code/CodeMirrorTextArea";
import { useDispatch } from "react-redux";
import { codeEditorActions } from "../../store/codeEditorSlice";
import AnswerPreview from "./AnswerPreview";
import withCodeEditor from "../../HOC/withCodeEditor";

function RunCodeTab({ lesson, screen, codeEditor }) {
  const customRunCode = codeEditor.customRunCode;

  const dispatch = useDispatch();

  const runCodeEditor = useMemo(
    () => (
      <CodeMirrorTextArea
        id="codemirror-editor-run-code"
        value={customRunCode || ""}
        language={lesson.language}
        setValue={(newCode) =>
          dispatch(
            codeEditorActions.setCustomRunCode({
              screenId: screen.id,
              customRunCode: newCode,
            })
          )
        }
        showOutput
      >
        <AnswerPreview screen={screen} />
      </CodeMirrorTextArea>
    ),
    [lesson.language, screen.id]
  );

  return runCodeEditor;
}

export default withCodeEditor(RunCodeTab);
